/*
 * THIS FILE WAS GENERATED BY "@atproto/lex". DO NOT EDIT.
 */

export * from './requestPlcOperationSignature.defs'
export { main as default } from './requestPlcOperationSignature.defs'
